module.exports = __webpack_public_path__ + "static/scale-model-of-the-basement-attractions-in-aurora-illinois-1acd2dfbf79ff155d12ef89b95751433.png";